import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Heading } from '@alefeducation/ui-elements-library-core';
import AddPermissionsModal from './AddPermissionsModal/AddPermissionsModal';
import { usePermissionCategoryContext } from './PermissionCategoryContext';
import AssignedPermissionList from './AssignedPermissionList';
import { rowStyles } from './common.styled';
import {
  ADD_PERMISSIONS,
  ASSIGNED_PERMISSIONS,
  EDIT_PERMISSIONS,
  MODULE,
  NO_PERMISSIONS_ASSIGNED,
  PERMISSIONS_TITLE,
} from '../../../utils/constants';
import appLocalStorage from '../../../utils/AppLocalStorage';

const StyledContainer = styled.div`
  width: 450px;
  padding: 24px 24px 40px;
`;

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledAPContainer = styled.div`
  margin-top: 18px;
  border: 1px solid #ecedef;
  border-radius: 8px;
`;

const StyledAPHeader = styled.div`
  background-color: ${({ theme }: any) => theme.colors.primary[10]};
  padding: 16px;

  ${rowStyles}
`;

const StyledBody = styled.div`
  padding: 16px;
  max-height: 25vh;
  overflow: auto;
`;

const Permissions = () => {
  const [showAddPermissionsModal, setAddPermissionsModal] = useState(false);
  const { isEdit, assignedPermissions, onPermissionDialogToggle } =
    usePermissionCategoryContext();
  const buttonText = isEdit ? EDIT_PERMISSIONS : ADD_PERMISSIONS;

  return (
    <StyledContainer data-testid="create-role-permissions">
      <Flex>
        <Heading variant="heading-small">{PERMISSIONS_TITLE}</Heading>
        <Button
          variant="secondary"
          size="sm"
          disabled={appLocalStorage.isViewOnlyRole()}
          onClick={() => {
            onPermissionDialogToggle(true);
            setAddPermissionsModal(true);
          }}
        >
          {buttonText}
        </Button>
      </Flex>

      <StyledAPContainer data-testid="assigned-permission-table">
        <StyledAPHeader>
          <Heading variant="heading-small">{`${ASSIGNED_PERMISSIONS} (${assignedPermissions.length})`}</Heading>
          <Heading variant="heading-small">{MODULE}</Heading>
        </StyledAPHeader>

        <StyledBody className="body">
          {assignedPermissions.length === 0 ? (
            <Heading variant="heading-small" weight="light" color="primary.100">
              {NO_PERMISSIONS_ASSIGNED}
            </Heading>
          ) : (
            <AssignedPermissionList />
          )}
        </StyledBody>
      </StyledAPContainer>
      <AddPermissionsModal
        open={showAddPermissionsModal}
        setShowModal={setAddPermissionsModal}
      />
    </StyledContainer>
  );
};

export default Permissions;
